(function () {
  var selectors = {
    cart: ".rebuy-cart__flyout",
    items: "[data-rebuy-component=\"cart-items\"] .rebuy-cart__flyout-item",
    title: "[data-rebuy-component=\"title-bar\"], #rebuy-cart-title",
    subtotal: "[data-rebuy-component=\"cart-subtotal\"] .rebuy-cart__flyout-subtotal-label span",
    footer: "[data-rebuy-cart-anchor=\"footer\"]",
    bodyAnchor: "[data-rebuy-cart-anchor=\"body\"]",
    checkout: "[data-rebuy-component=\"checkout-area\"]",
    discount: "[data-rebuy-component=\"discount-input\"]",
    progressBar: "[data-rebuy-component=\"progress-bar\"], .rebuy-cart__progress-bar-container",
    progressGifts: ".rebuy-cart__progress-gifts",
    progressPrompt: "#rebuy-cart__progress-bar-meter-label, .rebuy-cart__progress-bar-prompt",
    progressFill: ".rebuy-cart__progress-bar-meter-fill",
  };
  var openRetryCount = 0;
  var openRetryTimer = null;
  var fallbackTimer = null;
  var inventoryHydrationTimer = null;
  var inventoryHydrationId = 0;

  function callIfFunction(target, method) {
    if (!target || typeof target[method] !== "function") {
      return false;
    }

    try {
      target[method]();
      return true;
    } catch (error) {
      return false;
    }
  }

  function openRebuyCart() {
    var rebuy = window.Rebuy;
    var opened = false;

    callIfFunction(rebuy && rebuy.Cart, "fetch");
    callIfFunction(rebuy && rebuy.Cart, "refresh");
    callIfFunction(rebuy && rebuy.SmartCart, "refresh");

    opened = callIfFunction(rebuy && rebuy.SmartCart, "show") || opened;
    opened = callIfFunction(rebuy && rebuy.SmartCart, "open") || opened;
    opened = callIfFunction(rebuy && rebuy.Cart, "show") || opened;
    opened = callIfFunction(rebuy && rebuy.Cart, "open") || opened;

    document.dispatchEvent(new CustomEvent("rebuy:smartcart:show", { bubbles: true }));
    document.dispatchEvent(new CustomEvent("rebuy:cart:show", { bubbles: true }));

    if (isRebuyCartVisible()) {
      openRetryCount = 0;
      setTimeout(hideNativeCartDrawer, 150);
      return;
    }

    if (openRetryCount >= 20) {
      openRetryCount = 0;
      fallbackNativeCartDrawer(false);
      return;
    }

    openRetryCount += 1;
    clearTimeout(openRetryTimer);
    openRetryTimer = setTimeout(openRebuyCart, 250);
  }

  function isRebuyCartVisible() {
    var cart = document.querySelector(selectors.cart);

    if (!cart) {
      return false;
    }

    var root = cart.closest(".rebuy-cart, [data-rebuy-cart]");
    var target = root || cart;
    var style = window.getComputedStyle(target);

    return style.display !== "none" && style.visibility !== "hidden" && target.getBoundingClientRect().width > 0;
  }

  function fallbackNativeCartDrawer(allowRedirect) {
    var drawer = document.getElementById("cart-drawer");

    if (drawer && typeof drawer.show === "function") {
      drawer.show();
      return;
    }

    if (allowRedirect) {
      if (window.Shopify && Shopify.routes && Shopify.routes.root) {
        window.location.href = Shopify.routes.root + "cart";
      } else {
        window.location.href = "/cart";
      }
    }
  }

  function queueFallbackNativeCartDrawer(allowRedirect) {
    clearTimeout(fallbackTimer);
    fallbackTimer = setTimeout(function () {
      if (!isRebuyCartVisible()) {
        fallbackNativeCartDrawer(allowRedirect);
      }
    }, 5500);
  }

  function hideNativeCartDrawer() {
    var drawer = document.getElementById("cart-drawer");

    if (!drawer) {
      return;
    }

    if (typeof drawer.hide === "function") {
      drawer.hide();
    }

    drawer.removeAttribute("open");
    drawer.classList.remove("is-open", "is-visible");
  }

  function routesRoot() {
    return window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root : "/";
  }

  function lowInventoryThreshold() {
    var threshold = window.themeVariables && window.themeVariables.settings
      ? parseInt(window.themeVariables.settings.rebuyLowInventoryThreshold, 10)
      : 3;

    return Number.isFinite(threshold) ? threshold : 3;
  }

  async function submitProductForm(event) {
    var form = event.target;

    if (!form || !form.matches('form[action*="/cart/add"]')) {
      return;
    }

    event.preventDefault();
    event.stopImmediatePropagation();

    if (event.submitter && event.submitter.getAttribute("aria-busy") === "true") {
      return;
    }

    if (!form.checkValidity()) {
      form.reportValidity();
      return;
    }

    var idInput = form.querySelector('[name="id"]');

    if (idInput) {
      idInput.disabled = false;
    }

    var submitButtons = Array.prototype.slice.call(form.elements).filter(function (element) {
      return element.type === "submit";
    });

    submitButtons.forEach(function (submitButton) {
      submitButton.setAttribute("aria-busy", "true");
    });

    document.documentElement.dispatchEvent(new CustomEvent("theme:loading:start", { bubbles: true }));

    try {
      var sectionsToBundle = [];

      document.documentElement.dispatchEvent(new CustomEvent("cart:prepare-bundled-sections", {
        bubbles: true,
        detail: { sections: sectionsToBundle },
      }));

      var formData = new FormData(form);
      var variantId = idInput && idInput.value ? idInput.value : formData.get("id");

      formData.set("sections", sectionsToBundle.join(","));

      if (variantId) {
        formData.set("sections_url", routesRoot() + "variants/" + variantId);
      }

      var response = await fetch(routesRoot() + "cart/add.js", {
        body: formData,
        method: "POST",
        headers: {
          "Accept": "application/json",
          "X-Requested-With": "XMLHttpRequest",
        },
      });
      var responseJson = await response.json();

      if (!response.ok) {
        form.dispatchEvent(new CustomEvent("cart:error", {
          bubbles: true,
          detail: { error: responseJson.description || responseJson.message || "Unable to add item to cart." },
        }));
        document.dispatchEvent(new CustomEvent("cart:refresh"));
        return;
      }

      var cartContent = await (await fetch(routesRoot() + "cart.js")).json();
      cartContent.sections = responseJson.sections || {};

      form.dispatchEvent(new CustomEvent("variant:add", {
        bubbles: true,
        detail: {
          items: responseJson.hasOwnProperty("items") ? responseJson.items : [responseJson],
          cart: cartContent,
          onSuccessDo: formData.get("on_success"),
        },
      }));

      document.documentElement.dispatchEvent(new CustomEvent("cart:change", {
        bubbles: true,
        detail: {
          baseEvent: "rebuy:variant:add",
          onSuccessDo: formData.get("on_success"),
          cart: cartContent,
        },
      }));

      openRebuyCart();
      queueFallbackNativeCartDrawer(false);
    } catch (error) {
      form.dispatchEvent(new CustomEvent("cart:error", {
        bubbles: true,
        detail: { error: "Unable to add item to cart." },
      }));
    } finally {
      submitButtons.forEach(function (submitButton) {
        submitButton.removeAttribute("aria-busy");
      });
      document.documentElement.dispatchEvent(new CustomEvent("theme:loading:end", { bubbles: true }));
    }
  }

  function updateCartText(cart) {
    var itemCount = cart.querySelectorAll(selectors.items).length;
    var title = cart.querySelector(selectors.title);
    var subtotal = cart.querySelector(selectors.subtotal);
    var cartRoot = cart.closest("#rebuy-cart, .rebuy-cart");

    if (cartRoot) {
      cartRoot.classList.toggle("rebuy-cart--empty", itemCount === 0);
    }

    if (title && itemCount) {
      var titleText = "Your Cart (" + itemCount + ")";

      if (title.textContent !== titleText) {
        title.textContent = titleText;
      }
    }

    if (subtotal && subtotal.textContent !== "Subtotal") {
      subtotal.textContent = "Subtotal";
    }
  }

  function normalizeText(text) {
    return (text || "").replace(/\s+/g, " ").trim();
  }

  function getProductHandleFromRow(row) {
    var link = row.querySelector('.rebuy-cart__flyout-item-product-title[href*="/products/"], .rebuy-cart__flyout-item-media a[href*="/products/"]');

    if (!link) {
      return "";
    }

    try {
      var url = new URL(link.getAttribute("href"), window.location.origin);
      var match = url.pathname.match(/\/products\/([^/]+)/);

      return match ? decodeURIComponent(match[1]) : "";
    } catch (error) {
      return "";
    }
  }

  function findCartItemForRow(row, cartItems, usedIndexes, fallbackIndex) {
    var handle = getProductHandleFromRow(row);
    var variantTitle = normalizeText(row.querySelector(".rebuy-cart__flyout-item-variant-title")?.textContent);
    var matchedIndex = cartItems.findIndex(function (item, index) {
      return !usedIndexes[index] && item.handle === handle && normalizeText(item.variant_title) === variantTitle;
    });

    if (matchedIndex < 0) {
      matchedIndex = cartItems.findIndex(function (item, index) {
        return !usedIndexes[index] && item.handle === handle;
      });
    }

    if (matchedIndex < 0 && cartItems[fallbackIndex] && !usedIndexes[fallbackIndex]) {
      matchedIndex = fallbackIndex;
    }

    if (matchedIndex < 0) {
      return null;
    }

    usedIndexes[matchedIndex] = true;
    return cartItems[matchedIndex];
  }

  async function fetchCartInventory() {
    var section = document.querySelector(".shopify-section--rebuy-cart-inventory");
    var sectionId = section && section.id
      ? section.id.replace(/^shopify-section-/, "")
      : "rebuy-cart-inventory";
    var response = await fetch(routesRoot() + "?section_id=" + encodeURIComponent(sectionId));

    if (!response.ok) {
      return { items: [] };
    }

    var html = await response.text();
    var doc = new DOMParser().parseFromString(html, "text/html");
    var json = doc.getElementById("rebuy-cart-inventory-data");

    if (!json) {
      return { items: [] };
    }

    return JSON.parse(json.textContent || "{\"items\":[]}");
  }

  function updateLowInventoryElement(row, inventoryQuantity, threshold) {
    var existing = row.querySelector(".rebuy-cart__flyout-item-low-stock");
    var shouldShow = Number.isFinite(inventoryQuantity) && inventoryQuantity > 0 && inventoryQuantity <= threshold;

    if (!shouldShow) {
      if (existing) {
        existing.remove();
      }

      row.classList.remove("has-low-inventory");
      return;
    }

    var lowStock = existing || document.createElement("div");
    var variantTitle = row.querySelector(".rebuy-cart__flyout-item-variant-title");
    var productTitle = row.querySelector(".rebuy-cart__flyout-item-product-title");

    lowStock.className = "rebuy-cart__flyout-item-low-stock";
    lowStock.textContent = "Only " + inventoryQuantity + " left";

    if (!existing) {
      if (variantTitle) {
        variantTitle.insertAdjacentElement("afterend", lowStock);
      } else if (productTitle) {
        productTitle.insertAdjacentElement("afterend", lowStock);
      } else {
        row.appendChild(lowStock);
      }
    }

    row.classList.add("has-low-inventory");
  }

  function queueLowInventoryHydration() {
    clearTimeout(inventoryHydrationTimer);
    inventoryHydrationTimer = setTimeout(hydrateLowInventory, 150);
  }

  async function hydrateLowInventory() {
    var threshold = lowInventoryThreshold();
    var currentHydrationId = ++inventoryHydrationId;
    var carts = Array.prototype.slice.call(document.querySelectorAll(selectors.cart));

    if (!carts.length) {
      return;
    }

    if (threshold <= 0) {
      carts.forEach(function (cart) {
        Array.prototype.slice.call(cart.querySelectorAll(".rebuy-cart__flyout-item-low-stock")).forEach(function (item) {
          item.remove();
        });
        Array.prototype.slice.call(cart.querySelectorAll(selectors.items)).forEach(function (item) {
          item.classList.remove("has-low-inventory");
        });
      });
      return;
    }

    try {
      var cart = await (await fetch(routesRoot() + "cart.js")).json();
      var inventory = await fetchCartInventory();
      var inventoryByVariantId = (inventory.items || []).reduce(function (byVariantId, item) {
        byVariantId[String(item.variant_id)] = item;
        return byVariantId;
      }, {});

      if (currentHydrationId !== inventoryHydrationId) {
        return;
      }

      carts.forEach(function (cartElement) {
        var usedIndexes = {};

        Array.prototype.slice.call(cartElement.querySelectorAll(selectors.items)).forEach(function (row, index) {
          var cartItem = findCartItemForRow(row, cart.items || [], usedIndexes, index);

          if (!cartItem) {
            updateLowInventoryElement(row, null, threshold);
            return;
          }

          var inventoryItem = inventoryByVariantId[String(cartItem.variant_id)];
          var isInventoryTracked = inventoryItem && inventoryItem.inventory_management;
          var inventoryQuantity = isInventoryTracked && typeof inventoryItem.inventory_quantity === "number"
            ? inventoryItem.inventory_quantity
            : null;

          updateLowInventoryElement(row, inventoryQuantity, threshold);
        });
      });
    } catch (error) {
      // Inventory messaging is decorative; leave the cart usable if lookup fails.
    }
  }

  function parseMoney(text) {
    var normalized = (text || "").replace(/[^0-9,.-]/g, "").replace(/,/g, "");
    var value = parseFloat(normalized);

    return Number.isFinite(value) ? value : 0;
  }

  function getCartDisplayTotal(cart) {
    var subtotalAmount = cart.querySelector(".rebuy-cart__flyout-subtotal-amount span:not(.sr-only)");

    if (subtotalAmount) {
      return parseMoney(subtotalAmount.textContent);
    }

    return Array.prototype.slice.call(cart.querySelectorAll(selectors.items)).reduce(function (total, item) {
      var price = parseMoney(item.querySelector(".rebuy-cart__flyout-item-price .rebuy-money span:not(.sr-only)")?.textContent);
      var quantityText = item.querySelector(".rebuy-cart__flyout-item-quantity-widget-label")?.textContent || "1";
      var quantity = parseInt(quantityText.replace(/\D/g, ""), 10) || 1;

      return total + price * quantity;
    }, 0);
  }

  function formatMoneyLike(amount, sample) {
    var symbolMatch = (sample || "").match(/[$€£¥₱₹₩₫₦₭₴₺₽₪฿₡₲₵₸₼₾₿]/);
    var symbol = symbolMatch ? symbolMatch[0] : "";
    var number = amount.toLocaleString(undefined, {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
    var hasSpace = symbol && new RegExp(symbol.replace(/[.*+?^${}()|[\]\\]/g, "\\$&") + "\\s").test(sample || "");

    return symbol ? symbol + (hasSpace ? " " : "") + number : number;
  }

  function getProgressPercent(cart, prompt) {
    var component = prompt.closest('[data-rebuy-component="progress-bar"]') || cart;
    var fill = component.querySelector(selectors.progressFill);
    var percent = fill ? parseFloat(fill.getAttribute("aria-valuenow")) : NaN;

    if (!Number.isFinite(percent) && fill) {
      percent = parseFloat(fill.style.width);
    }

    return Number.isFinite(percent) ? percent : 0;
  }

  function correctProgressLabels(cart) {
    Array.prototype.slice.call(cart.querySelectorAll(selectors.progressPrompt)).forEach(function (prompt) {
      var text = prompt.textContent || "";
      var percent = getProgressPercent(cart, prompt);
      var cartTotal = getCartDisplayTotal(cart);

      if (!/0(?:[,.]0{2})/.test(text) || percent <= 0 || percent >= 99.9 || cartTotal <= 0) {
        return;
      }

      var remaining = cartTotal * ((100 - percent) / percent);
      var formattedRemaining = formatMoneyLike(remaining, text);
      var fixedText = text.replace(/(?:[^\d\s.,-]+\s*)?0(?:[,.]0{2})/, formattedRemaining);

      if (prompt.textContent !== fixedText) {
        prompt.textContent = fixedText;
      }
    });
  }

  function ensurePromoToggle(cart) {
    var footer = cart.querySelector(selectors.footer);
    var checkout = cart.querySelector(selectors.checkout);
    var discount = footer ? footer.querySelector(selectors.discount) : null;

    if (discount) {
      var staleFallback = footer.querySelector(".kl-rebuy-discount-shell");

      if (staleFallback) {
        staleFallback.remove();
      }

      enhanceDiscountComponent(discount);
      return;
    }

    if (!footer || !checkout || footer.querySelector(".kl-rebuy-discount-shell")) {
      return;
    }

    var shell = document.createElement("div");
    shell.className = "rebuy-cart__flyout-discount-container kl-rebuy-discount-shell";
    shell.innerHTML = [
      '<button class="kl-rebuy-discount-toggle" type="button" aria-expanded="false" aria-controls="kl-rebuy-discount-panel-current">',
      "Add a Promo Code",
      "</button>",
      '<div id="kl-rebuy-discount-panel-current" hidden></div>',
    ].join("");

    footer.insertBefore(shell, footer.firstChild);
  }

  function enhanceDiscountComponent(discount) {
    var form = discount.querySelector(".rebuy-cart__discount-form");
    var input = discount.querySelector("#rebuy-cart__discount-input, .rebuy-cart__discount-input, .rebuy-input");

    if (!form) {
      return;
    }

    if (input) {
      input.setAttribute("placeholder", "Enter code");
      input.setAttribute("aria-label", "Enter discount code");
    }

    var id = form.id || "kl-rebuy-discount-panel-" + Math.random().toString(36).slice(2);
    var toggle = discount.querySelector(".kl-rebuy-discount-toggle");

    discount.classList.add("kl-rebuy-discount-collapsible");
    form.id = id;

    if (!toggle) {
      toggle = document.createElement("button");
      toggle.className = "kl-rebuy-discount-toggle";
      toggle.type = "button";
      toggle.textContent = "Add a Promo Code";
      discount.insertBefore(toggle, form);
    }

    if (!discount.classList.contains("is-expanded")) {
      form.hidden = true;
    }

    toggle.setAttribute("aria-controls", id);
    toggle.setAttribute("aria-expanded", discount.classList.contains("is-expanded") ? "true" : "false");
  }

  function ensureGuarantee(cart) {
    var checkout = cart.querySelector(selectors.checkout);

    if (!checkout || checkout.querySelector(".kl-rebuy-guarantee")) {
      return;
    }

    var guarantee = document.createElement("div");
    guarantee.className = "kl-rebuy-guarantee";
    guarantee.textContent = "30 day money back guarantee";
    checkout.appendChild(guarantee);
  }

  function updateProgressGiftsToggle(cartRoot) {
    var expanded = cartRoot.classList.contains("rebuy-cart--progress-gifts-expanded");

    cartRoot.querySelectorAll(".kl-rebuy-progress-gifts-toggle").forEach(function (toggle) {
      toggle.setAttribute("aria-expanded", expanded ? "true" : "false");
      toggle.setAttribute("aria-label", expanded ? "Hide free gifts" : "Show free gifts");
    });
  }

  function ensureProgressGiftsToggle(cart) {
    var cartRoot = cart.closest("#rebuy-cart, .rebuy-cart") || cart;

    cartRoot.querySelectorAll(selectors.progressBar).forEach(function (progressBar, index) {
      var gifts = progressBar.querySelector(selectors.progressGifts);
      var giftsTitle = gifts ? gifts.querySelector(".rebuy-cart__progress-gifts-title") : null;
      var giftsContainer = gifts ? gifts.querySelector(".rebuy-cart__progress-gifts-container") : null;
      var toggle = progressBar.querySelector(".kl-rebuy-progress-gifts-toggle");

      if (!gifts || !giftsContainer) {
        if (toggle) {
          toggle.remove();
        }

        return;
      }

      if (!giftsContainer.id) {
        giftsContainer.id = "kl-rebuy-progress-gifts-container-" + index + "-" + Math.random().toString(36).slice(2);
      }

      if (!toggle) {
        toggle = document.createElement("button");
        toggle.className = "kl-rebuy-progress-gifts-toggle";
        toggle.type = "button";
        toggle.innerHTML = '<span class="sr-only">Toggle free gifts</span>';
      }

      if (giftsTitle && giftsTitle.nextElementSibling !== toggle) {
        giftsTitle.insertAdjacentElement("afterend", toggle);
      } else if (!giftsTitle && gifts.firstElementChild !== toggle) {
        gifts.insertBefore(toggle, gifts.firstChild);
      }

      toggle.setAttribute("aria-controls", giftsContainer.id);
    });

    updateProgressGiftsToggle(cartRoot);
  }

  function isScrollableElement(element) {
    if (!element) {
      return false;
    }

    return element.scrollHeight > element.clientHeight + 1;
  }

  function getCartScrollCandidates(cartRoot) {
    var selectorsToCheck = [
      selectors.bodyAnchor,
      "[data-rebuy-cart-scroll-area]",
      "[data-smartcart-items]",
      "[data-rebuy-component=\"cart-items\"]",
      ".rebuy-cart__flyout-body",
      ".rebuy-cart__flyout-content",
      ".rebuy-cart__flyout-items",
      ".rebuy-cart__flyout",
    ];
    var candidates = [];

    selectorsToCheck.forEach(function (selector) {
      Array.prototype.slice.call(cartRoot.querySelectorAll(selector)).forEach(function (element) {
        if (candidates.indexOf(element) < 0) {
          candidates.push(element);
        }
      });
    });

    return candidates;
  }

  function updateCartScrollState(cartRoot) {
    var candidates = getCartScrollCandidates(cartRoot);
    var body = cartRoot.querySelector(selectors.bodyAnchor);
    var hasScrolled = candidates.some(function (element) {
      return isScrollableElement(element) && element.scrollTop > 1;
    });

    if (!hasScrolled && body) {
      var progressBar = body.querySelector('[data-rebuy-component="progress-bar"], .rebuy-cart__progress-bar-container');
      hasScrolled = !!progressBar && progressBar.getBoundingClientRect().top < body.getBoundingClientRect().top - 1;
    }

    cartRoot.classList.toggle("rebuy-cart--body-scrolled", hasScrolled);

    if (!hasScrolled) {
      cartRoot.classList.remove("rebuy-cart--progress-gifts-expanded");
    }

    updateProgressGiftsToggle(cartRoot);
  }

  function updateAllCartScrollStates() {
    document.querySelectorAll("#rebuy-cart, .rebuy-cart").forEach(updateCartScrollState);
  }

  function hydrateCart() {
    document.querySelectorAll(selectors.cart).forEach(function (cart) {
      updateCartText(cart);
      //correctProgressLabels(cart);
      ensurePromoToggle(cart);
      ensureGuarantee(cart);
      ensureProgressGiftsToggle(cart);
    });
    updateAllCartScrollStates();
    queueLowInventoryHydration();
  }

  document.addEventListener("click", function (event) {
    var progressGiftsToggle = event.target.closest(".kl-rebuy-progress-gifts-toggle");

    if (progressGiftsToggle) {
      var cartRoot = progressGiftsToggle.closest("#rebuy-cart, .rebuy-cart");

      if (cartRoot) {
        cartRoot.classList.toggle("rebuy-cart--progress-gifts-expanded");
        updateProgressGiftsToggle(cartRoot);
      }

      return;
    }

    var toggle = event.target.closest(".kl-rebuy-discount-toggle");

    if (!toggle) {
      var cartLink = event.target.closest(".header__cart-link a, a[aria-controls=\"cart-drawer\"]");

      if (!cartLink || window.themeVariables && window.themeVariables.settings && window.themeVariables.settings.pageType === "cart") {
        return;
      }

      event.preventDefault();
      openRebuyCart();
      queueFallbackNativeCartDrawer(true);
      return;
    }

    var panel = document.getElementById(toggle.getAttribute("aria-controls"));
    var component = toggle.closest("[data-rebuy-component=\"discount-input\"]");

    if (!panel) {
      return;
    }

    var expanded = toggle.getAttribute("aria-expanded") === "true";
    toggle.setAttribute("aria-expanded", expanded ? "false" : "true");
    panel.hidden = expanded;

    if (component) {
      component.classList.toggle("is-expanded", !expanded);
    }
  });

  document.addEventListener("submit", submitProductForm, true);
  document.addEventListener("scroll", updateAllCartScrollStates, true);

  document.addEventListener("variant:add", function () {
    openRebuyCart();
    queueFallbackNativeCartDrawer(false);
  });

  document.documentElement.addEventListener("cart:change", function (event) {
    if (!event.detail || event.detail.baseEvent !== "variant:add") {
      return;
    }

    openRebuyCart();
    queueFallbackNativeCartDrawer(false);
  });

  var observer = new MutationObserver(hydrateCart);

  if (document.body) {
    observer.observe(document.body, { childList: true, subtree: true });
    hydrateCart();
  } else {
    document.addEventListener("DOMContentLoaded", function () {
      observer.observe(document.body, { childList: true, subtree: true });
      hydrateCart();
    });
  }
})();
